import Vue from 'vue'
import BootstrapVue, { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import bottomNavigationVue from 'bottom-navigation-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import 'boxicons'
import VueMask from 'v-mask'
import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'
import 'vue-select/dist/vue-select.css'
// Global Components
import './global-components'
import './assets/css/global.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// 3rd party plugins

import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import './registerServiceWorker'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'
import '@/libs/Notifier'

/* import the fontawesome core */

/* import font awesome icon component */

/* import specific icons */


// bottomNavigationVue
Vue.use(bottomNavigationVue)

Vue.use(ToastificationContent)
// v-mask
Vue.use(VueMask)

// bottom-navigation-vue
Vue.use(bottomNavigationVue)

// BSV Plugin Registration
Vue.use(BootstrapVue)
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

if (localStorage.getItem('accessToken') !== null) {
  (async () => {
    try {
      store.commit('auth/setIsAuth', true)

      const tokenIsValid = await store.dispatch('auth/checkToken')

      if (!tokenIsValid) {
        const refreshTokenValid = await store.dispatch('auth/tokenRefreshJwt')
        if (!refreshTokenValid) store.commit('auth/setIsAuth', false)
      }
    } catch (error) {
      store.commit('auth/setIsAuth', false)
    }
  })()
}

Vue.prototype.$capitalizeWords = function (text) {
  return text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
};

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
